// UI-tier constants — presentation concerns that both the Vue layer
// and the (rare) infra callback that emits UI coordinates share.
// Not fabric-internal, not domain — pure presentation.

// Vertical offset in CSS pixels between an object's mid-bottom anchor
// and the floating contextual menu positioned below it.
const CONTEXTUAL_MENU_OFFSET = 15;

export { CONTEXTUAL_MENU_OFFSET };
